import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { User } from '@/@types/auth';
import { TOKEN_NAME_IN_STORAGE } from '@/constants/api.constant';

type Session = {
  signedIn: boolean;
};

export type AuthState = {
  session: Session;
  user: User | null;
  tenantId: string;
};

type AuthAction = {
  setSessionSignedIn: (payload: boolean) => void;
  setUser: (payload: User | null) => void;
  setTenantId: (payload: string) => void;
};

const initialState: AuthState = {
  session: {
    signedIn: false,
  },
  user: null,
  tenantId: '',
};

export const useSessionUser = create<AuthState & AuthAction>()(
  persist(
    (set) => ({
      ...initialState,
      setSessionSignedIn: (payload) =>
        set((state) => ({
          session: {
            ...state.session,
            signedIn: payload,
          },
        })),
      setUser: (payload) =>
        set((state) => ({
          user: payload && {
            ...state.user,
            ...payload,
          },
        })),
      setTenantId: (payload) =>
        set(() => ({
          tenantId: payload,
        })),
    }),
    { name: 'sessionUser', storage: createJSONStorage(() => localStorage) },
  ),
);

export const useToken = () => {
  const setToken = (token: string) => {
    localStorage.setItem(TOKEN_NAME_IN_STORAGE, token);
  };

  return {
    setToken,
    token: localStorage.getItem(TOKEN_NAME_IN_STORAGE),
  };
};
